// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ZT6O","requiredAsterisk":"Info_requiredAsterisk__3oaTJ"};